
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proyectos",
      function () {
        return require("private-next-pages/proyectos/index.tsx");
      }
    ]);
  